<template>
   <div class="region">
        <el-form-item label="省：" prop="province">
            <el-select v-model="form.province" placeholder="请选择" @change="handleProvinceChange">
                <el-option v-for="(item, index) in provinceData" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="市：" prop="city">
            <el-select v-model="form.city" placeholder="请选择" @change="handleCityChange">
                <el-option v-for="(item, index) in cityData" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="区：" prop="district">
            <el-select v-model="form.district" placeholder="请选择" @change="handleDistrictChange">
                <el-option v-for="(item, index) in districtData" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="街道：" prop="street">
            <el-select v-model="form.street" placeholder="请选择">
                <el-option v-for="(item, index) in streetData" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
        </el-form-item>
   </div>
</template>

<script>
// 710000 台湾省
// 810000 香港特别行政区
// 820000 澳门特别行政区
// 暂无港澳台区以下数据
import pcasCode from '@/data/pcas-code.json';

export default {
  name: 'CRegion',
  props: {
      region: {
          type: Object,
          default() {
              return {};
          },
      },
  },
  data() {
    return {
        provinceData: pcasCode,
        cityData: [],
        districtData: [],
        streetData: [],

      form: {
        province: '',
        city: '',
        district: '',
        street: '',
      },
    };
  },
  watch: {
    form: {
      handler(value) {
        // console.log(value);
        this.$emit('change', value);
      },
      deep: true,
    },
    region: {
      handler() {
        // console.log(value);
        this.handleInit();
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
      this.handleInit();
  },
  methods: {
    // 初始化
    handleInit() {
        this.form.province = this.region.province || '';

        this.handleProvinceChange(() => {
            this.form.city = this.region.city || '';

            this.handleCityChange(() => {
                this.form.district = this.region.district || '';

                this.handleDistrictChange(() => {
                    this.form.street = this.region.street || '';
                });
            });
        });
    },
    // 省的值改变
    handleProvinceChange(callback) {
        // console.log(this.form.province);
        const tmpList = this.provinceData.filter(item => item.name === this.form.province);
        // console.log(tmpList);

        this.cityData = tmpList.length ? tmpList[0].children : [];
        this.districtData = [];
        this.streetData = [];

        this.form.city = '';
        this.form.district = '';
        this.form.street = '';

        typeof (callback) === 'function' && callback();
    },
    // 城市的值改变
    handleCityChange(callback) {
        // console.log(this.form.city);
        const tmpList = this.cityData.filter(item => item.name === this.form.city);

        this.districtData = tmpList.length ? tmpList[0].children : [];
        this.streetData = [];

        this.form.district = '';
        this.form.street = '';

        console.log(this.districtData);

        typeof (callback) === 'function' && callback();
    },
    // 区的值改变
    handleDistrictChange(callback) {
        // console.log(this.form.district);
        const tmpList = this.districtData.filter(item => item.name === this.form.district);

        this.streetData = tmpList.length ? tmpList[0].children : [];

        this.form.street = '';

        typeof (callback) === 'function' && callback();
    },
  },
};
</script>

<style lang="scss" scoped></style>
